export interface SuggestionType {
    id?: string; // Cambiado a string para coincidir con la API
    name: string;
    centerGroupId?: number;
    displayOrder?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

// Interface para la respuesta de la API
export interface SuggestionTypeApiResponse {
    id: string;
    title: string;
    centerGroupId: number;
}

// Interface para crear/actualizar en la API
export interface SuggestionTypeRequest {
    id: string;
    title: string;
    centerGroupId: number;
}

export interface SuggestionTypeFormData {
    name: string;
}